<template>
  <div>
    <v-autocomplete
      v-model="task"
      v-if="!readonly"
      variant="underlined"
      :items="tasks"
      item-title="name"
      item-value="id"
      label="Tasks"
      :hide-no-data="!search"
      placeholder="Start typing to Search"
      return-object
      hide-selected
      clearable
      v-model:search="search"
      :menu-props="{ maxWidth: '1400' }"      
    >
      <template v-slot:item="{ props, item }">
        <v-list-item v-bind="props" :title="item.raw.name">
          <template v-slot:title="{ title }">
            <div v-html="title" class="autocomplete-custom-0001"></div>
          </template>
        </v-list-item>
      </template>
      <template v-slot:no-data>
        <span class="px-3">No tasks where found. Would you like to <a href="#" @click.prevent="addTask">add this task</a>?</span>
      </template>
    </v-autocomplete>

    <div class="tasks-list container">
      <h4 v-if="readonly && selectedTasks && selectedTasks.length">Tasks</h4>
      <v-row v-for="task in selectedTasks || []" :key="task" align="center" :class="readonly ? 'my-2 py-2' : 'my-2 py-0'">
        <v-col cols="10" class="py-0">
          <a href="#" class="black-link" @click="onClick($event, task)">{{ getTaskName(task) }}</a>
        </v-col>
        <v-col cols="2" class="text-right py-0" v-if="!readonly">
          <v-btn @click="deleteSelectedTask(task)" icon="mdi-delete-outline" variant="text" >
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaskPicker',
  props: {
    tasks: Array,
    selectedTasks: Array,
    readonly: Boolean
  },
  data() {
    return {
      task: null,
      search: ''
    }
  },
  methods: {
    deleteSelectedTask(task) {
      this.$emit('deleteTask', this.tasks.find(t => t.clientID === task))
    },
    getTaskName(task) {
      const result = this.tasks.find(t => t.clientID === task)
      return result ? result.name : ''
    },
    onClick(event, task) {
      event.preventDefault()
      this.$emit('onClick', this.tasks.find(t => t.clientID === task))
    },
    addTask() {
      this.$emit('addTask', this.search)
    }
  },
  watch: {
    task(newSelection, oldSelection) {
      this.$emit('selectTask', newSelection, oldSelection)
      this.$nextTick(() => {
        this.task = null
      })
    }
  }
}
</script>

<style scoped>
.tasks-list {
  max-height: 400px;
  padding: 0 10px;
  overflow-y: scroll;
}

.tasks-list .v-row {
  border-bottom: 1px solid #ccc;
}

.black-link {
  color: #000000;
}
.autocomplete-custom-0001{
  white-space: normal;  
}
</style>
